import type {QueryKey} from '@tanstack/react-query';
import type {StrNum} from '_types';
import type {SearcherQueryKey} from '_types/swr';

import {joinUrl, query} from '_utils/url';

export function parseKey(key: QueryKey): string {
    return joinUrl(key.map(String));
}

export function parseSearcherKey(key: SearcherQueryKey): string {
    const route = key.slice(0, -1) as StrNum[];
    const params = key.at(-1)! as object;

    // @ts-ignore
    return joinUrl([...route, query(params, '?')] as const);
}

export function list2Ids(ids: string[]) {
    return ids.join(',');
}
